import { render, staticRenderFns } from "./DrinkingComparison.vue?vue&type=template&id=54d45932&scoped=true&"
import script from "./DrinkingComparison.vue?vue&type=script&lang=ts&"
export * from "./DrinkingComparison.vue?vue&type=script&lang=ts&"
import style0 from "./DrinkingComparison.vue?vue&type=style&index=0&id=54d45932&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d45932",
  null
  
)

export default component.exports